import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  OPEN: {
    color: theme.palette.statuses.open,
  },
  APPROVED: {
    color: theme.palette.statuses.approved,
  },
  CANCELLED: {
    color: theme.palette.statuses.cancelled,
  },
  COMPLETED: {
    color: theme.palette.statuses.completed,
  },
  INPROGRESS: {
    color: theme.palette.statuses.inProgress,
  },
  PENDING_APPROVAL: {
    color: theme.palette.statuses.pendingApproval,
  },
  CLOSED: {
    color: theme.palette.statuses.closed,
  },
  NONE: {
    color: theme.palette.statuses.none,
  },
  COMPLETE: {
    color: theme.palette.statuses.completed,
  },
  FAIL: {
    color: theme.palette.statuses.failed,
  },
  PREAUTH: {
    color: theme.palette.statuses.preauth,
  },
  DISPUTED: {
    color: theme.palette.statuses.disputed,
  },
  REFUNDED: {
    color: theme.palette.statuses.refunded,
  },
  NOTSTARTED: {
    color: theme.palette.statuses.notStarted,
  },
  STARTED: {
    color: theme.palette.statuses.started,
  },
  PREAUTHREFUNDED: {
    color: theme.palette.statuses.preauthRefunded,
  },
  circleIcon: {
    fontSize: 10,
    marginRight: 5,
  },
  completedIcon: {
    fontSize: 13,
    marginRight: 10,
  },
}));

export default useStyles;
